// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export const DirectMessageCode =
{
    CODE_ACCOUNT_STATUS: 1,
    CODE_PROPERTY: 2,
    CODE_INSTRUMENT: 3,
    CODE_QUOTE_1: 4,
    CODE_QUOTE_2: 5,
    CODE_OPEN_POSITION: 6,
    CODE_CLOSE_POSITION: 7,
    CODE_OPEN_ORDER: 8,
    CODE_REMOVE_ORDER: 9,
    CODE_SESSION: 10,
    CODE_QUOTE_INSTRUMENT_DAY_BAR: 11,
    CODE_CROSS_RATE: 12,
    CODE_ASSET_TYPE_MESSAGE: 13,
    CODE_XML_REPORT: 14,
    CODE_ROUTE: 15,
    CODE_REPORT_METADATA: 17,
    CODE_TRADE: 18,
    CODE_INSTRUMENT_TYPE: 19,
    CODE_ORDER_HISTORY: 20,
    CODE_ORDER_STATUS_CHANGED_MESSAGE: 21,
    // Сообщение об снятии приказа пользователем (клиентом)
    CODE_CANCEL_ORDER: 22,
    // Сообщение об отказе исполнения приказа
    CODE_REFUSE_ORDER_EXECUTE: 23,
    // Сообщении о закрытии диалога пользователем
    CODE_INSTRUMENT_PRICES: 25,
    CODE_REPORT_TYPE_MESSAGE: 26,
    CODE_NEWDIALOGCREATED: 27,
    // Запрос брокеру на создание отложенного (SL/TP) приказа
    CODE_XML_CREATE: 28,
    CODE_PFIX_RISK_PLAN_MESSAGE: 29,
    // Сообщение в XML формате.
    // Существуют различные реализации в большинстве своём основанные на одном суперклассе.
    CODE_XML: 30,
    CODE_QUOTE_3: 31,
    CODE_QUOTE_4: 32,
    CODE_INSTRUMENT_LIST_RESPONSE: 33,
    CODE_CROSSRATES_PLAN_MESSAGE: 34,
    CODE_TRADE_SESSION_STATUS_MESSAGE: 35,

    CODE_EXCHANGE_MESSAGE: 36,
    CODE_SUBSCRIBE_RESPONSE_MESSAGE: 37,
    CODE_INSTRUMENT_STRIKES_RESPONSE: 38,

    CODE_SOURCE_LIST: 39,
    CODE_REPORT_RESPONSE_MESSAGE: 40,
    CODE_SPREAD_PLAN_MESSAGE: 41,
    CODE_COMMISSION_PLAN_MESSAGE: 42,
    CODE_PFIX_TRADE_INSTRUMENT: 43,
    CODE_YTM: 44,
    CODE_BROKER_MESSAGE: 45,
    CODE_BRANDING_MESSAGE: 46,
    CODE_ACCOUNOPERATION_MESSAGE: 47,
    CODE_ACCOUNT_OPERATION_REQUEST_INFO_MESSAGE: 48,

    CODE_TRADING_SIGNAL_MESSAGE: 49,
    CODE_TRADING_SYSTEM_MESSAGE: 50,
    CODE_SUBSCRIPTION_STRATEGY_MESSAGE: 51,
    CODE_TRADING_SIGNAL_CANCEL_MESSAGE: 52,
    CODE_TRADING_SIGNAL_SEEN_MESSAGE: 53,
    CODE_TRADING_SYSTEM_REMOVE_MESSAGE: 54,

    CODE_REPORT_GROUP_RESPONSE: 55,
    CODE_PFIX_CUSTODIAL_PLAN_MESSAGE: 56,
    CODE_MARGIN_RESPONSE: 57,
    CODE_RISK_WARN_MESSAGE: 58,
    CODE_MARGINCALL: 59,

    CODE_PORTFOLIO_STATISTICS: 60,

    CODE_ALERT_MESSAGE: 61,
    CODE_REPLACE_ALERT_MESSAGE: 62,
    CODE_CONTROL_ALERT_COMAND_MESSAGE: 63,

    CODE_PFIX_TRADE_SESSION_SWITCH: 64,
    CODE_NEWS_SUBSCRIBE_RESPONSE: 65,
    CODE_NEWS_MESSAGE: 66,

    CODE_PFIX_TOKEN_VERIFY_RESPONSE: 67,
    CODE_USER_GROUP: 68,

    CODE_GET_SNAPSHOT_RESPONSE: 69,

    // Product
    CODE_PFIX_PRODUCT_MESSAGE: 70,
    CODE_PFIX_PRODUCT_DOCUMENT_RESP: 71,
    CODE_PFIX_PRODUCT_SUBSCRIPTION_MANAGEMENT_RESP: 72,

    // External links
    CODE_PFIX_EXTERNAL_LINK_MESSAGE: 73,
    CODE_PFIX_EXTERNAL_LINK_REMOVE_MESSAGE: 74,

    CODE_PORTFOLIO_MODEL: 75,
    CODE_PORTFOLIO_REALTIME_STATISTICS: 76,
    CODE_PORTFOLIO_SYSTEM: 77,
    CODE_PORTFOLIO_INVESTOR: 78,

    // Algorithm
    CODE_PFIX_ALGORITHMS_AVAILABLE_MESSAGE: 79,
    CODE_PFIX_ALGORITHM_SUBSCRIBE_MESSAGE: 80,
    CODE_PFIX_ALGORITHM_MARKET_CONSENSUS_MESSAGE: 81,
    CODE_PFIX_ALGORITHM_HIGH_LOW_MESSAGE: 82,
    CODE_PFIX_ALGORITHM_GAINERS_LOSERS_MESSAGE: 83,
    CODE_PFIX_ALGORITHM_TOP_VOLUME_MESSAGE: 84,
    CODE_PFIX_ALGORITHM_HISTORICAL_GAINER_LOSER_TOPS_MESSAGE: 85,

    CUSTOM_LIST_MESSAGE: 86,

    BM_HISTORY_RESPONSE: 87,
    BM_COUNTER_MESSAGE: 88,

    CODE_PRICE_LIMITS_MESSAGE: 89,

    CODE_PFIX_FUNDING_RATE_MARKUP_PLAN_MESSAGE: 90,

    CODE_PFIX_CLOSE_ACCOUNT_RESPONSE_MESSAGE: 91
};
Object.freeze(DirectMessageCode);
